const version = '2.4.17'
const commit = `${process.env.COMMIT_HASH ? process.env.COMMIT_HASH : ''}`

function getProjectName() {
  const platform = process.env.PLATFORM || ''
  const isWebview = process.env.WEBVIEW === '1'
  const isSportBuild = process.env.OWN_SPORT

  let projectName = platform

  if (isWebview) {
    projectName += '-webview'
  } else {
    projectName += '-web'
  }
  if (isSportBuild) {
    projectName += '-sport'
  }
  return projectName
}

function getRelease() {
  return `${version}@${commit}`
}

export default {
  version,
  commit,
  getProjectName,
  getRelease,
}
